module.exports = __webpack_public_path__ + "img/BrandyTorres10anos.e94b29cb.jpg";